import {channelOfSnapshots} from './sagas'
import {
  ResearchState,
  ResearchStateTab,
  ResearchStateTabs,
} from '$src/bootstrap/Store'
import {getMstStore} from '$src/bootstrap/rootSaga'
import {IStore} from '$src/bootstrap/Store'
import {fork, take, cancel} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {getSnapshot} from 'mobx-state-tree'
import {keyBy} from 'lodash'
import callEndpoint from '$src/api/sagas/callEndpoint'
import setComparableSaleResearchState, {
  ServerSnapshot,
} from '$src/api/endpoints/comparableSaleResearchState/setComparableSaleResearchState'

const ourSnapshotToServerSnapshot = (
  snapshot: typeof ResearchState.SnapshotType,
): ServerSnapshot => {
  // debugger
  const ourTabs: typeof ResearchStateTabs.SnapshotType = snapshot.tabs

  const snapshotForServer = {
    version: snapshot.version,
    housingCorporationId: snapshot.housingCorporationId,
    tabs: ourTabs.list.map((tabId: string) => {
      const ourTab: typeof ResearchStateTab.SnapshotType = ourTabs.byId[tabId]
      return {
        name: ourTab.name,
        id: ourTab.id,
        enabled: ourTab.enabled,
        query: ourTab.query,
        foundItems: {
          queried: ourTab.foundItems.queried,
          selectedPageSize: ourTab.foundItems.selectedPageSize,
        },
        data: ourTab.foundItems.list.map((itemId: number) => ({
          ...ourTab.foundItems.byId[itemId],
          disabled:
            !ourTab.foundItems.selectedIds[itemId] &&
            !ourTab.foundItems.selectedIdsRent[itemId] &&
            !ourTab.foundItems.selectedIdsOldData[itemId],
        })),
      }
    }),
  }

  return snapshotForServer
}

export const serverSnapshotToOurSnapshot = (
  server: ServerSnapshot,
): typeof ResearchState.SnapshotType => {
  // debugger
  const tabs = server.tabs.map(t => {
    const selectedIds: any = {}
    const selectedIdsRent: any = {}
    const selectedIdsOldData: any = {}
    const rows: any = []
    t.data.forEach(r => {
      const {disabled, ...rest} = r
      if (!disabled) {
        if (r.dataType === 'rent') {
          selectedIdsRent[rest.id] = true
        } else if (r.dataType === 'premise') {
          selectedIds[rest.id] = true
        } else if (!r.dataType) {
          selectedIdsOldData[rest.id] = true
        }
      }
      rows.push(rest)
    })

    return {
      id: t.id,
      name: t.name,
      enabled: t.enabled,
      query: t.query,
      foundItems: {
        queried: t.foundItems.queried,
        byId: keyBy(rows, 'id'),
        list: t.data.map(({id}) => id),
        selectedIds,
        selectedIdsRent,
        selectedIdsOldData,
        selectedPageSize: t.foundItems.selectedPageSize,
      },
    }
  })

  return {
    version: server.version,
    housingCorporationId: server.housingCorporationId,
    tabs: {
      byId: keyBy(tabs, 'id'),
      list: tabs.map(({id}) => id),
    },
  }
}

export default function* watchAndPersistResearchState(hcid: string): Generator {
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const theChannel: $FixMe = yield channelOfSnapshots(
    mstStore.researchStates.byHousingCorporationId.get(hcid)!,
  )
  let lastTask: $FixMe = null
  while (true) {
    yield take(theChannel)
    /**
     * Avoid persisting researchState on frozen housing corporations
     */
    if (mstStore.housingCorporations.byId.get(hcid)!.isFrozen()) {
      continue
    }
    if (lastTask) {
      yield cancel(lastTask)
      lastTask = null
    }
    lastTask = yield fork(persistResearchState, hcid)
  }
}

function* persistResearchState(hcid: string): Generator {
  yield delay(50)
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const snapshot: typeof ResearchState.SnapshotType = getSnapshot(
    mstStore.researchStates.byHousingCorporationId.get(hcid) as any,
  )
  if (!snapshot) return

  const tabs: typeof ResearchStateTabs.SnapshotType = snapshot.tabs

  let tabsThatDontYetHaveAQurtyResultExist = false
  for (const tabId in tabs.byId) {
    const tab: typeof ResearchStateTab.SnapshotType = tabs.byId[tabId]
    if (tab.foundItems.queried !== true) {
      tabsThatDontYetHaveAQurtyResultExist = true
      break
    }
  }

  if (tabsThatDontYetHaveAQurtyResultExist === true) {
    // let's wait for the result of those tabs first
    return
  } else {
    const snapshotForServer = ourSnapshotToServerSnapshot(snapshot)

    try {
      yield callEndpoint(setComparableSaleResearchState, snapshotForServer)
    } catch (e) {
      console.log('>> Could not persist research state', snapshot)
      console.error(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/sagas/watchAndPersistResearchState.tsx